export const getUserAgent = () => navigator.userAgent;
export const getHash = () => window.location.pathname.substr(1);
export const toCapitalCase = (str) => str.split(' ').map(i => i[0].toUpperCase() + i.substring(1).toLowerCase()).join(' ');
export const getBWId = () => localStorage.getItem('BWId');
export const setBWId = (BWId) => { if (BWId !== null) localStorage.setItem('BWId', BWId); }
export const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
export const getGUID = () => (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
export const getCustomer = () => JSON.parse(localStorage.getItem('customer')) || {};
export const saveCustomer = (Customer) => localStorage.setItem('customer', JSON.stringify({ FullName: Customer.FullName, Phone: Customer.Phone, Email: Customer.Email, Address: Customer.Address }));

export const getLanguages = (MenuSets, selectedLanguage) => {
    var Ids = MenuSets.map(menu => parseInt(menu.Language));
    var LanguageCodes = Ids.map(Lang => getLanguageCode(Lang));
    var Count = MenuSets.length;
    var Index = Ids.indexOf(selectedLanguage);

    return {
        Ids: Ids,
        Codes: LanguageCodes,
        Count: Count,
        Index: Index,
        Language: selectedLanguage
    }
}

export const getInitialLanguage = (MenuSets, BrowserLanguage) => {
    var Languages = MenuSets.map(menu => parseInt(menu.Language)); // Get all the languages from the forms list
    if (Languages.includes(BrowserLanguage)) return BrowserLanguage; // If the browser language exits in the list, return that one
    return Languages[0] // If browser language is not in the list, return the language of first form
}

export const getBrowserLanguage = () => {
    const lang = navigator.language || navigator.userLanguage;

    if (lang === 'tr-TR')
        return 1;
    if (lang === 'ru-RU')
        return 3;
    if (lang.startsWith('ar'))
        return 4;

    return 2;  // If the browser does not have any of the languages above, return English
}

export const getLanguageCode = (language) => {
    if (language === 2)
        return 'EN';
    if (language === 1)
        return 'TR';
    if (language === 3)
        return 'RU';
    if (language === 4)
        return 'عربى';
    if (language === 6)
        return 'FR';
    if (language === 7)
        return 'AZ';
}

export const getLanguageFromCode = (language) => {
    if (language === 'EN')
        return 2;
    if (language === 'TR')
        return 1;
    if (language === 'RU')
        return 3;
    if (language === 'AR')
        return 4;
    if (language === 'FR')
        return 6;
    if (language === 'AZ')
        return 7;
}

const parseColor = (color) => {
    if (typeof color !== 'string') return null;

    var value = color.trim().toLowerCase();

    var rgb = value.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*[\d.]+\s*)?\)$/);
    if (rgb) return [parseFloat(rgb[1]), parseFloat(rgb[2]), parseFloat(rgb[3])];

    var hex = value.charAt(0) === '#' ? value.substring(1) : value;
    if (!/^[0-9a-f]+$/.test(hex)) return null;

    if (hex.length === 3 || hex.length === 4) // #rgb and #rgba
        return [parseInt(hex[0] + hex[0], 16), parseInt(hex[1] + hex[1], 16), parseInt(hex[2] + hex[2], 16)];

    if (hex.length === 6 || hex.length === 8) // #rrggbb and #rrggbbaa
        return [parseInt(hex.substring(0, 2), 16), parseInt(hex.substring(2, 4), 16), parseInt(hex.substring(4, 6), 16)];

    return null;
}

// Returns true when the background is light enough to need dark content on top of it.
// Falls back to true for missing or unparsable colors, since the app renders on a light theme by default.
export const isLightBackground = (bgColor) => {
    var rgb = parseColor(bgColor);
    if (rgb === null) return true;

    return rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 186;
}
